// ALARM FILTER TREE

import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"

//Translation
import { withTranslation } from "react-i18next"

// Alert id:s
import { allAlerts } from "constants/alerts"

//  antd
import { TreeSelect, ConfigProvider } from "antd"
const { SHOW_PARENT } = TreeSelect

const AlarmFilter = props => {
  const [filteredDataTemp, setFilteredDataTemp] = useState([])
  const [typeFilter, setTypeFilter] = useState(["all"])
  const [customize] = useState(true)
  const [alarmData, setAlarmData] = useState([])

  useEffect(() => {
    if (props.needsAlarmType) {
      // Map props.data to include alarm_type
      const alarmData = props.data.map(item => {
        const alarmType = props.t("AlarmTitles." + item.alarm_id)
        return {
          ...item,
          alarm_type: alarmType,
        }
      })
      setAlarmData(alarmData)
    } else {
      setAlarmData(props.data)
    }
  }, [props.data])

  // Mapping and setting props.t to alarmtypes
  const dataMapping = data => {
    if (data) {
      let d = []
      for (const a of data) {
        d.push({
          title: props.t("AlarmTitles." + a),
          value: props.t("AlarmTitles." + a),
          key: props.t("AlarmTitles." + a),
        })
      }
      return d
    }
  }

  const treeData = [
    {
      title: props.t("All"),
      value: "all",
      key: "all",
      children: Object.values(allAlerts).map(a => ({
        title: props.t(a.title),
        value: a.key,
        key: a.key,
        children: dataMapping(a.ids),
      })),
    },
  ]

  // Filter by selected types
  useEffect(() => {
    if (alarmData != undefined && alarmData.length > 0) {
      setFilteredDataTemp([])
      if (typeFilter == "all") {
        setFilteredDataTemp(alarmData)
      }
      if (typeFilter != "all") {
        let alarms = []
        let tempValue = []
        setFilteredDataTemp([])
        // Push datas from alarm name
        alarmData.filter(f => {
          typeFilter.map(v => {
            if (f.alarm_type == v) {
              tempValue.push(f)
            }
          })
        })

        // Filtering selected category id values
        Object.values(allAlerts)
          .filter(f => typeFilter?.includes(f.key))
          .map(i => {
            alarms.push(...i.ids)
          })

        // Push datas from alarm category
        for (const element of alarms) {
          alarmData.filter(data => {
            if (data.alarm_type == props.t("AlarmTitles." + element)) {
              tempValue.push(data)
            }
          })
        }
        setFilteredDataTemp(tempValue)
      }
    }
  }, [alarmData, typeFilter])

  // Send filtered to parent
  useEffect(() => {
    props.setFilteredEntries(filteredDataTemp)
  }, [filteredDataTemp])

  const customizeRenderEmpty = () => (
    <div className="mt-3" style={{ textAlign: "center" }}>
      <p>{props.t("Alarm type not found")}</p>
    </div>
  )

  const tProps = {
    treeData,
    value: typeFilter,
    allowClear: true,
    treeDefaultExpandAll: true,
    treeCheckable: true,
    showCheckedStrategy: SHOW_PARENT,
    placeholder: props.t("Alarm types"),
    style: {
      width: "100%",
    },
  }

  return (
    <>
      <ConfigProvider renderEmpty={customize && customizeRenderEmpty}>
        <TreeSelect
          popupClassName="custom-scrollbar"
          listHeight={"auto"}
          virtual={false}
          dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
          style={{ maxHeight: 200 + "px" }}
          onChange={value => {
            setTypeFilter(value)
          }}
          {...tProps}
        />
      </ConfigProvider>
    </>
  )
}
AlarmFilter.propTypes = {
  t: PropTypes.any,
  data: PropTypes.any,
  setFilteredEntries: PropTypes.any,
  needsAlarmType: PropTypes.bool,
}

export default withTranslation()(AlarmFilter)
